<template>
  <SideBar :sidebarItems="sidebarItems" companyType="airline"/>
</template>

<script setup>
import SideBar from "@/components/organisms/SideBar.vue";

const sidebarItems = [
  {icon: "graph", label: "Dashboard", to: {name: "Dashboard"}},
  {icon: "takeoff", label: "Charter Requests", to: {name: "AirlineRequestList"}},
  {icon: "quote", label: "Quotes", to: {name: "AirlineQuoteList"}},
  {icon: "contract", label: "Contracts",to: {name: "AirlineContracts"}},
  {icon: "box", label: "Shipments", to: {name: "AirlineShipments"}},
  {icon: "message", label: "Message", badge: 3, to: {name: "AirlineMessages"}},
]
</script>

<style scoped>

</style>